import React from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { Button } from '@3plearning/react-components';
import { activateModal, dismissModal } from '../../containers/modal-manager/modal-manager-actions';
import { createAssignModal } from '../upf-assign-modal/upf-assign-modal';
import { assign, unAssign } from '../../containers/upf-assign/upf-assign-actions';
import FooterWrapper from './styled';
import { AssignIcon, UnAssignIcon } from '../../helpers/icon-dictionary';
import { useTracking } from '../../analytics';

const Footer = (props) => {
  const { i18n } = props;
  const { studentAssignments, actionInProgress, selectedTopics, filteredStudents,
    studentUnAssignments, selectedAssessmentType } = useSelector(state => state.UPFAssignReducer);
  const selectedProduct = useSelector(state => state.product, shallowEqual);
  const selectedCourse = useSelector(state => state.UPFAssignReducer.selectedCourse);
  const dispatch = useDispatch();
  const { trackAssignmentConfirmed, trackAssignmentUnassigned } = useTracking();

  const onAssignHandler = (duration, randomize, scheduleDateTime, durationType) => {
    const requestData = {
      studentAssignments,
      productId: selectedProduct && selectedProduct.id,
      courseId: selectedCourse && selectedCourse.id,
      courseVersion: selectedCourse && selectedCourse.version,
      assessmentTypeId: selectedAssessmentType.id,
      duration,
      durationType,
      randomize,
      scheduleDateTime,
      filteredStudents
    };
    trackAssignmentConfirmed(studentAssignments.length);
    dispatch(assign(requestData, selectedTopics, i18n));
    dispatch(dismissModal());
  };

  const onUnAssignHandler = () => {
    const requestData = {
      productId: selectedProduct && selectedProduct.id,
      courseId: selectedCourse && selectedCourse.id,
      courseVersion: selectedCourse && selectedCourse.version,
      assessmentTypeId: selectedAssessmentType.id,
      filteredStudents
    };
    const assignmentIds = studentUnAssignments.map(val => val.assignmentId);
    trackAssignmentUnassigned(studentUnAssignments.length);
    dispatch(unAssign(assignmentIds, requestData, selectedTopics, i18n));
  };

  const closeAssignModal = () => {
    dispatch(dismissModal());
  };

  const getAssignInfo = () => {
    const assignInfo = {
      assessmentType: selectedAssessmentType.name
    };
    dispatch(activateModal(createAssignModal(onAssignHandler, closeAssignModal, assignInfo, i18n)));
  };

  const assignStudentCount = studentAssignments.length;
  const unassignStudentCount = studentUnAssignments.length;
  const assignButtonText = `${i18n.t`Assign`} (${assignStudentCount})`;
  const unassignButtonText = `${i18n.t`Unassign`} (${unassignStudentCount})`;
  const count = assignStudentCount + unassignStudentCount;
  const label = `${count} ${count === 1 ? i18n.t`Student selected` : i18n.t`Students selected`}`;

  return (
    <FooterWrapper>
      <div data-name="collapsed" className="buttonPanel collapsed">
        {label}
      </div>
      <div data-name="expanded" className="buttonPanel expanded">
        <div className="unassign" >
          <Button
            className="button"
            disabled={studentUnAssignments.length === 0 || actionInProgress}
            primary
            text={unassignButtonText}
            type={Button.LOZENGE}
            onClick={onUnAssignHandler}
            alignIcon="LEFT"
            icon={UnAssignIcon}
          />
        </div>
        <div className="assign" >
          <Button
            className="button"
            disabled={studentAssignments.length === 0 || actionInProgress}
            primary
            text={assignButtonText}
            type={Button.LOZENGE}
            onClick={getAssignInfo}
            alignIcon="LEFT"
            icon={AssignIcon}
          />
        </div>
      </div>
    </FooterWrapper>
  );
};

Footer.propTypes = {
  i18n: PropTypes.object
};

export default Footer;
